import React, { ReactElement, useMemo } from 'react';
import { ModulesType } from 'b2b-apps/shop/content/components/ModularPage';
import { useComponentsFromModules } from 'b2b-apps/shop/content/hooks';
import { resolveModules } from 'b2b-apps/shop/content/utils/modules';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const { content } = props;

    const modules = useMemo((): ModulesType => {
      const { isLoaded, data } = content;

      if (!isLoaded || !data) {
        return [];
      }

      if (data.container__main_content) {
        return resolveModules(data.container__main_content);
      }

      if (data.content) {
        const moduleData = {
          text_media: {
            title: data.title,
            text: data.content,
          },
        };

        return resolveModules(moduleData);
      }

      return [];
    }, [content]);

    const injectedProps: InjectedProps = {
      contentBlocks: useComponentsFromModules(modules),
    };

    return <Component {...injectedProps} />;
  };

  return WithContainer;
};

export { withContainer };
